import script from "./PasswordResetSetComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordResetSetComponent.vue?vue&type=script&setup=true&lang=js"

import "./PasswordResetSetComponent.vue?vue&type=style&index=0&id=8ae88626&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ae88626"]])

export default __exports__